var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col p-4 bg-white flex-1"},[_c('ChatActiveView',{staticClass:"flex-1"}),_c('ChatFooter',{staticClass:"h-10"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }